// React Imports
import type { SVGAttributes } from 'react'

const Figma = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width='1em' height='1em' viewBox='-50 0 300 300' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path fill='#0acf83' d='M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z' />
      <path fill='#a259ff' d='M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z' />
      <path fill='#f24e1e' d='M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z' />
      <path fill='#ff7262' d='M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z' />
      <path fill='#1abcfe' d='M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z' />
    </svg>
  )
}

export default Figma
